<template>
  <div class="bj-container">
    <div class="side">
      <HundredSubject
        @subClick="handleSub"
        @requestAll="handleAll"
        title="研究方向"
      ></HundredSubject>
    </div>
    <div class="content">
      <template v-if="total > 0 || scrollFlag">
        <OneMessage :messageList="messageList"/>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
      </template>
      <NoData v-if="total <= 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import OneMessage from "./components/OneMessage.vue";
import HundredSubject from "./components/HundredSubject.vue";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    OneMessage,
    HundredSubject,
    NoData,
    Scroll
  },
  data() {
    return {
      scrollFlag: false,
      isEnd: false,
      filterFlag: false,
      messageList: [], // 每个人的信息
      pageNum: 1,
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 12,
      },
    };
  },
  created() {
    this.getFamilyList(this.params); // 百家
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight = document.documentElement.clientHeight + document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd ) {
        if (this.filterFlag) {
          this.getFamilyList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.getFamilyList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    handleAll() {
      this.messageList = [];
      this.filterFlag = false;
      delete this.params.subjects;
      // 请求全部
      this.getFamilyList(this.params);
    },
    handleSub(v, item) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.messageList = [];
      }
      let obj = {}
      obj.levelOne = item.id;
      obj.levelTwo = v.id;
      this.params.subjects = obj
      this.getFamilyList({
        ...this.params,
      });
    },
    async getFamilyList(data) {
      this.scrollFlag = true
      this.isEnd = false
      const resp = await this.$apis.hundredServe.getFamilyList(data);
      this.total = +resp.data.total;
      this.messageList.push(...resp.data.list);
      this.scrollFlag = false
      this.isEnd = this.pageNum >= this.total / 12
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
::v-deep .ivu-tree-empty {
  margin: 30px;
}
.ivu-tree {
  margin: 0 13px;
}
.bj-container {
  display: flex;
  .side {
    width: 300px;
    height: 559px;
    background-color: #fff;
    // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  }
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .content {
    margin-top: 25px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    width: 900px;
    background-color: #fff;
    border-radius: 10px;
  }
}
</style>
